export default __webpack_public_path__ + "static/media/EAST2490.34I-34653_-19249_0.10173ba1.jpg";